module.exports = __webpack_public_path__ + "img/home_fr4.fe067810.png";